import React from "react";
import { Modal, Typography } from "components";
import { formatDateTime } from "utils/helper";

const ViewTerminal = ({ terminalToView, handleClose }) => {
  const getTerminalDetails = () => {
    const {
      createDate,
      deviceType,
      imei,
      oem,
      serialNumber,
      status,
      terminalId,
      region,
      state,
      terminalAddress
    } = terminalToView || {};

    const terminalDetails = [
      { label: "OEM", value: oem },
      { label: "Terminal ID", value: terminalId },
      { label: "IMEI", value: imei },
      { label: "Serial Number", value: serialNumber },
      { label: "Status", value: status },
      { label: "Device Type", value: deviceType },
      { label: "Region", value: region },
      { label: "State", value: state },
      { label: "Terminal Address", value: terminalAddress },
      { label: "Date Registered", value: formatDateTime(createDate) },
    ];

    return terminalDetails;
  };

  return (
    <Modal showModal={!!terminalToView} onClose={handleClose} size="lg">
      <Typography variant="body0" className={"text-center mt-4"}>
        Terminal Detail
      </Typography>

      <div className="row user-detail-container py-3">
        {getTerminalDetails().map(({ label, value }, key) => (
          <div className="col-md-6 mt-3" key={key}>
            <Typography variant="body3">
              {label}: &nbsp;{value}
            </Typography>
          </div>
        ))}
        {terminalToView?.rejectionComment &&
          terminalToView?.status === "CREATION_REJECTED" && (
            <div className="user-detail-container py-4">
              <Typography variant="body3">
                Rejection Comment: <br /> {terminalToView.rejectionComment}
              </Typography>
            </div>
          )}
      </div>
    </Modal>
  );
};

export default ViewTerminal;
